"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var CAN_SPAM_URI = 'content/api/v4/can-spam-settings';
var LIMIT = 500;
var SNAKE_CASING = 'snake';

var CanSpamAPI =
/*#__PURE__*/
function () {
  function CanSpamAPI() {
    (0, _classCallCheck2.default)(this, CanSpamAPI);
  }

  (0, _createClass2.default)(CanSpamAPI, null, [{
    key: "getCanSpamSettings",
    value: function getCanSpamSettings() {
      return _apiClient.default.get("" + CAN_SPAM_URI, {
        query: {
          casing: SNAKE_CASING,
          limit: LIMIT
        }
      });
    }
  }, {
    key: "createCanSpamSetting",
    value: function createCanSpamSetting(canSpamSetting) {
      return _apiClient.default.post("" + CAN_SPAM_URI, {
        query: {
          casing: SNAKE_CASING
        },
        data: canSpamSetting
      });
    }
  }, {
    key: "updateCanSpamSetting",
    value: function updateCanSpamSetting(canSpamSetting) {
      return _apiClient.default.put(CAN_SPAM_URI + "/" + canSpamSetting.id, {
        query: {
          casing: SNAKE_CASING
        },
        data: canSpamSetting
      });
    }
  }, {
    key: "deleteCanSpamSetting",
    value: function deleteCanSpamSetting(_ref) {
      var id = _ref.id;
      return _apiClient.default.delete(CAN_SPAM_URI + "/" + id, {
        query: {
          casing: SNAKE_CASING
        }
      });
    }
  }]);
  return CanSpamAPI;
}();

exports.default = CanSpamAPI;
module.exports = exports.default;